import ExlyImage from "common/Components/ExlyImage";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { getS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";
import React from "react";

export const SeeReferenceModal = () => {
  const setIsSeeReferenceModalOpen = useAdminPanelStore(
    (state) => state.setIsSeeReferenceModalOpen
  );
  const isSeeReferenceModalOpen = useAdminPanelStore(
    (state) => state.isSeeReferenceModalOpen
  );
  const {
    title = "",
    description = "",
    url = "",
    height,
  } = isSeeReferenceModalOpen || {};

  if (!isSeeReferenceModalOpen) return <></>;
  return (
    <ExlyModal
      title={title}
      header={title}
      open={isSeeReferenceModalOpen}
      onClose={() => setIsSeeReferenceModalOpen(null)}
      padded={false}
      footer={false}
      modal_props={{
        modalPaperClassName: "tw-w-[429px]",
      }}
      customFooter={<></>}
    >
      <div className="p-3">
        <div className="tw-text-[rgba(39,37,34,0.60)] tw-text-[14px] tw-font-normal tw-leading-[18px] tw-tracking-[0.23px]">
          {description}
        </div>
        <div className="tw-text-[rgba(0,0,0,0.85)] tw-text-[14px] tw-font-medium tw-leading-normal tw-mt-[16px]">
          Locations :
        </div>
        <div
          className={`tw-rounded-lg tw-bg-[#EBE8FD] tw-flex tw-items-center tw-justify-center !w-100 ${height} tw-mt-3  tw-mb-4`}
        >
          <ExlyImage
            src={getS3AssetCDNUrl(url)}
            alt="ref-img"
            id="ref-img"
            className="tw-w-[calc(100%-24px)] tw-h-[calc(100%-24px)]"
            loading="eager"
          />
        </div>
      </div>
    </ExlyModal>
  );
};
